<template>
  <div>
    <div style="overflow:hidden">
      <div class="headerImg"></div>
    </div>
    <div style="overflow:hidden">
      <div class="content">
        <div class="row maker-as">
          <div
            style="font-size: 46px;font-weight: bold;padding: 58px 0 15px 0px;color:#333;text-align: center;width:100%"
          >放薪管家</div>
          <p class="title-p">ABOUT US</p>
          <div style="margin-bottom:50px;text-align:center">
            <span style="display: inline-block;width: 80px;height: 3px;background-color: #f38303;"></span>
          </div>

          <p class="content">放薪管家是以科技赋能新就业形态的商税结算，为传统企业或者平台型灵活用工企业提供数字化技术驱动的佣金管理、批量发放、</p>
          <p
            class="content"
            style="text-indent: 1em;"
          >实时支付、纳税申报、开具发票、账单管理、风控管理等一体化系统服务，有云端管理账户和服务接口对接的两种服务模式。</p>

          <div class="asImg" style="padding:16px 0;">
            <img src="https://file.lgbfss.com/www/official/images/maker/img.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="maker-content content">
        <div class="asImg">
          <img src="../../public/images/maker/makerContent.jpg" />
        </div>
        <div class="content-text content">
          <h1>放薪管家的优势</h1>
          <p class="title-p">PREPONDERANCE</p>
          <div style="margin-bottom:50px;text-align:center">
            <span style="display: inline-block;width: 80px;height: 3px;background-color: #fff;"></span>
          </div>
          <div class="content-row">
            <div class="content-col1">
              <img src="https://file.lgbfss.com/www/official/images/maker/bg1.svg" class="col-img1" />
              <img
                src="https://file.lgbfss.com/www/official/images/maker/bg1-1.svg"
                class="col-img1-1"
              />
              <span>优势一</span>
              <div>
                <p>企业链条完整</p>
                <p>确保三流一致入账合规</p>
              </div>
            </div>
            <div class="content-col2">
              <img src="https://file.lgbfss.com/www/official/images/maker/bg2.svg" class="col-img2" />
              <img
                src="https://file.lgbfss.com/www/official/images/maker/bg3-1.svg"
                class="col-img2-2"
              />
              <span>优势二</span>
              <div>
                <p>降低管理成功</p>
                <p>同时降低运营成本</p>
              </div>
            </div>
            <div class="content-col3">
              <img src="https://file.lgbfss.com/www/official/images/maker/bg3.svg" class="col-img3" />
              <img
                src="https://file.lgbfss.com/www/official/images/maker/bg2-1.svg"
                class="col-img3-3"
              />
              <span>优势三</span>
              <div>
                <p>降低用工成本</p>
                <p>同时降低用工风险</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="overflow:hidden">
      <div class="content">
        <div class="row maker-as maker-client">
          <h1>客户案例</h1>
          <p class="title-p">CLIENT CASE</p>
          <div style="margin-bottom:50px;text-align:center">
            <span style="display: inline-block;width: 80px;height: 3px;background-color: #f38303;"></span>
          </div>
        </div>
        <div class="client-content" style="margin-top: 80px;height:450px">
          <div class="content-text">
            <p>王先生是一家快消品销售公司的负责人，因为经常做促销活动，不定期的需要大量的促销人员。但因时间灵活，且多是与个人合作，因此常出现工时计算不清晰，业务不规范，发票链条不完整的问题。</p>
            <p>王先生通过陕西日报的报道了解到零工创客共享服务平台，并且和平台达成了合作。因为平台全线上进行签约、任务发包、实时结算等，大大提高了支付的效率和准确率，王先生的企业降低了用工成本，同时，获得平台开具的服务费发票，也避免了之前常出现的无票支出的现象，也降低了税务风险。王先生表示：“灵活用工这种方式对我们这类企业来说能降低很大的用工成本，现在国家也鼓励采用灵活用工的方式，选择和零工创客服务平台合作，感觉他们的服务团队很专业，业务模式合规，非常值得信赖。”</p>
          </div>
          <div class="content-video">
            <img src="../../public/images/maker/makerClentVideo.jpg" />
          </div>
        </div>
      </div>
    </div>
    <div style="overflow:hidden">
      <img src="../../public/images/footer.jpg" />
    </div>
    <Nav></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/footer";
import Nav from "../components/nav";
export default {
  components: {
    Footer,
    Nav,
  },
};
</script>

<style scoped>
.headerImg {
  height: 713px;
  background-image: url("https://file.lgbfss.com/www/official/images/maker/maker.png");
  background-position: center top;
  background-repeat: no-repeat;
  background-size: auto;
}

/* 关于创客 */
.maker-as {
  margin-top: 40px;
}
.maker-as h1 {
  width: 100%;
  line-height: 100px;
  letter-spacing: 7px;
  color: #333333;
  text-align: center;
  font-size: 46px;
  font-weight: bold;
}
.maker-as .title-p {
  font-size: 20px;
  color: #cbcbcb;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  text-align: center;
}
.maker-as .content {
  letter-spacing: 1px;
  color: #060606;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  margin-top: 10px;
  padding: 0px;
}
.maker-as .asImg {
  width: 100%;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.maker-as .asImg img {
  height: auto;
}
/* 零工创客优势 */
.maker-content .asImg {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.maker-content .asImg img {
  height: 550px;
  width: 1920px;
  opacity: 1.5;
}
.content-box {
  /* background: url("/public/images/maker/makerContent.jpg"); */
  overflow-x: hidden;
  padding-bottom: 60px;
}
.content-box::-webkit-scrollbar {
  display: none;
}

.maker-content {
  position: relative;
}
.maker-content .content-text {
  position: absolute;
  top: 340px;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
}
.maker-content .content-text h1 {
  width: 100%;
  font-family: "MicrosoftYaHei-Bold";
  font-size: 46px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 100px;
  letter-spacing: 7px;
  color: #ffff;
  text-align: center;
}
.maker-content .content-text .title-p {
  font-size: 20px;
  color: #cbcbcb;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  text-align: center;
}
.maker-content .content-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -20px;
}
.content-col1,
.content-col2,
.content-col3 {
  margin: 0 20px;
  flex: 0%;
  height: 356px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.content-col1 .col-img1-1,
.col-img2-2,
.col-img3-3,
.col-img4-4 {
  display: none;
}
.content-col1 > div,
.content-col2 > div .content-col3 > div {
  margin-top: 10px;
}
.content-col1 img,
.content-col2 img,
.content-col3 img {
  width: 110px;
  height: 90px;
  margin: 0px auto;
  margin-top: 65px;
}
.content-col1 span,
.content-col2 span,
.content-col3 span {
  font-size: 30px;
  color: #fff;
  text-align: center;
  margin-top: 20px;
}
.content-col1 p,
.content-col2 p,
.content-col3 p {
  font-size: 18px;
  color: #fff;
  font-weight: normal;
  text-align: center;
}
.content-col1:hover {
  background-color: #72c4f3;
  opacity: 0.7;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.4);
}
.content-col1:hover .col-img1 {
  display: none;
}
.content-col1:hover .col-img1-1 {
  display: block;
}
.content-col1:hover span {
  color: black;
}
.content-col1:hover p {
  color: black;
}
.content-col2:hover {
  background-color: #72c4f3;
  opacity: 0.7;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.4);
}
.content-col2:hover .col-img2 {
  display: none;
}
.content-col2:hover .col-img2-2 {
  display: block;
}
.content-col2:hover span {
  color: black;
}
.content-col2:hover p {
  color: black;
}
.content-col3:hover {
  background-color: #72c4f3;
  opacity: 0.7;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.4);
}
.content-col3:hover .col-img3 {
  display: none;
}
.content-col3:hover .col-img3-3 {
  display: block;
}
.content-col3:hover span {
  color: black;
}
.content-col3:hover p {
  color: black;
}

/* 创客案例 */
.maker-client {
  margin-top: 100px;
}
.maker-client .client-content {
  position: relative;
  height: 100vh;
  /* overflow:auto; */
}
.maker-client .client-content::after {
  content: ".";
  height: 0;
  display: block;
  clear: both;
  visibility: hidden;
}
.client-content .content-text {
  width: 737px;
  padding: 30px 40px 70px 40px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.34);
  border: solid 1px #ffffff;
  z-index: 9;
  box-shadow: 0 0 10px 2px #dbdbdb;
  position: absolute;
}
.client-content .content-text p:nth-child(1) {
  width: 631px;
  font-family: "MicrosoftYaHei";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #666666;
  margin-bottom: 40px;
  line-height: 25px;
}
.client-content .content-text p:nth-child(2) {
  font-family: "MicrosoftYaHei";
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #333333;
  line-height: 25px;
}
.client-content .content-video {
  position: absolute;
  top: 200px;
  right: 0px;
  width: 573px;
  height: 430px;
  background-color: #1d1d1d;
  box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.32);
  cursor: pointer;
  /* opacity: 0.42; */
}
</style>